var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 170,
    viewBox: "0 0 142 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140.703,
    height: 126.633,
    transform: "translate(0.648438 0.40625)",
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.0018 86.2371C80.521 86.2371 88.2379 78.8352 88.2379 69.7045C88.2379 60.5738 80.521 53.1719 71.0018 53.1719C61.4825 53.1719 53.7656 60.5738 53.7656 69.7045C53.7656 78.8352 61.4825 86.2371 71.0018 86.2371Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4725 114.166C36.1846 100.073 52.313 89.2614 71.0095 89.0469C89.7059 89.2828 105.834 100.073 108.546 114.166C108.978 116.376 107.826 118.37 105.402 119.636C86.4418 129.504 55.5771 129.504 36.5926 119.636C34.1686 118.37 33.0165 116.376 33.4485 114.166H33.4725Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 140.703,
    height: 42.2109,
    transform: "translate(0.648438 127.039)",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/icon_avatar.e087f0196ad317da6aa5f305625b36b6.svg";
export { ForwardRef as ReactComponent };